import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { TRANSLATIONS } from "@/lib/pfd";

const LanguageContext = createContext(null);

const detectLang = () => {
  try {
    if (typeof window !== "undefined") {
      const url = new URLSearchParams(window.location.search);
      const q = url.get("lang");
      if (q === "fr" || q === "en") return q;
    }
    const stored = localStorage.getItem("bs_lang");
    if (stored === "fr" || stored === "en") return stored;
  } catch (err) {
    console.warn("[lang] detection failed, defaulting to en:", err);
  }
  return "en";
};

const persist = (l) => {
  try {
    localStorage.setItem("bs_lang", l);
    document.documentElement.lang = l;
  } catch (err) {
    console.warn("[lang] persistence unavailable:", err);
  }
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => detectLang());

  useEffect(() => {
    try {
      document.documentElement.lang = lang;
    } catch (err) {
      console.warn("[lang] could not set document lang:", err);
    }
  }, [lang]);

  const setLang = (l) => {
    if (l === "fr" || l === "en") {
      setLangState(l);
      persist(l);
    }
  };

  const toggleLang = () => {
    setLangState((prev) => {
      const next = prev === "fr" ? "en" : "fr";
      persist(next);
      return next;
    });
  };

  const t = TRANSLATIONS[lang];

  const value = useMemo(() => ({ lang, setLang, toggleLang, t }), [lang, t]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
